import {create} from 'zustand';
import {createJSONStorage, persist} from 'zustand/middleware';

interface AuthRedirectState {
  redirectUrl: string | null;
  updateRedirectUrl: (redirectUrl: string | null) => void;
}

export const authRedirectStoreKey = '@blesk/auth-redirect';

export const bleskAuthRedirectStore = create(
  persist<AuthRedirectState>(
    (set) => ({
      redirectUrl: null,
      updateRedirectUrl: (redirectUrl: string | null) => set({redirectUrl}),
    }),
    {name: authRedirectStoreKey, storage: createJSONStorage(() => sessionStorage)},
  ),
);
